'use client';

import React from 'react';
import useAuthenticatedUser from '@dr-pam/common-components/Hooks/useAuthenticatedUser';
import SignUpButton from '../auth/SignUpButton';
import AccountLink from './navbar/auth/AccountLink';
import LoginLink from './navbar/auth/LoginLink';
import LoginButton from './navbar/auth/LoginButton';
import SignUpLink from './navbar/auth/SignUpLink';
import { SubMenu } from './NavBar';

export type AuthLinkProps = {
	activeMenu: SubMenu;
	className?: string;
	onClick?: (item: SubMenu) => void;
	onCloseLogin: () => void;
	onCloseSignUp: () => void;
	onNavigate: () => void;
	backIcon?: string;
};

export default function AuthLinks(props: AuthLinkProps) {
	const { activeMenu, className, onClick, onCloseLogin, onCloseSignUp, onNavigate, backIcon } = props;
	const { user, isLoading } = useAuthenticatedUser();

	if (user) {
		return <AccountLink isLoading={isLoading} className={`nav-item ${className ?? ''}`} />;
	}

	return (
		<>
			<LoginButton className={`desktop-only ${className ?? ''}`} isLoading={isLoading} />
			<LoginLink
				active={activeMenu === SubMenu.LOGIN}
				className={`mobile-only ${className ?? ''}`}
				isLoading={isLoading}
				onClick={() => onClick?.(SubMenu.LOGIN)}
				onClose={onCloseLogin}
				backIcon={backIcon}
			/>
			<SignUpButton className={`auth-links signup-link nav-item desktop-only ${className ?? ''}`}>
				<span>{isLoading ? 'Loading...' : 'sign up'}</span>
			</SignUpButton>
			<SignUpLink
				active={activeMenu === SubMenu.SIGN_UP}
				className={`mobile-only ${className ?? ''}`}
				onClick={() => onClick?.(SubMenu.SIGN_UP)}
				onClose={onCloseSignUp}
				onNavigate={onNavigate}
				backIcon={backIcon}
			/>
		</>
	);
}
